import { get } from "lodash";
import {
  takeLatest,
  takeEvery,
  call,
  cancel,
  put,
  all
} from "redux-saga/effects";
import { subscribe } from "pusher-redux";

import { CHARGE, ENTITIES, USAGE } from "../actions/actionConstants.js";
import { PUSHER } from "../../constants/pusher.js";
import { createAction } from "../actions/actionUtils.js";

import { getEntitySaga, createEntitySaga } from "./apiSagas.js";
import { getHydraResultAsArray } from "../../utils/utils.js";
import { RESOURCE_KEYS } from "../../constants/entity.js";

function* getEntityDependenciesSaga(entity, dependencies) {
  if (!dependencies || dependencies.length < 1) return null;

  let dependencyCalls = [];

  for (let i = 0; i < dependencies.length; i++) {
    const dependency = dependencies[i];
    const id = entity[dependency];

    // we need to use the usage and charge stores until we move all resources to the ephemeral entities store
    // otherwise the selector and component logic will break
    let actionEntity = ENTITIES;
    if (dependency === RESOURCE_KEYS.CHARGE) actionEntity = CHARGE;
    if (dependency === RESOURCE_KEYS.USAGE) actionEntity = USAGE;

    if (id) {
      dependencyCalls.push(
        call(
          getEntitySaga,
          actionEntity,
          { autoComplete: false },
          createAction(actionEntity.GET, { ["@id"]: id })
        )
      );
    }
  }

  return yield all(dependencyCalls);
}

function* entityChoiceSaga(action) {
  // console.log("entityChoiceSaga action:", action);
  if (!action.options || !action.options.doNotReset) {
    yield put(createAction(ENTITIES.RESET));
  }

  try {
    const result = yield call(
      getEntitySaga,
      ENTITIES,
      { autoComplete: false },
      action
    );

    const resultAsArray = getHydraResultAsArray(result);
    const dependencies = get(action, "dependencies", null);

    for (let i = 0; i < resultAsArray.length; i++) {
      const entity = resultAsArray[i];
      if (dependencies && dependencies.length > 0) {
        yield getEntityDependenciesSaga(entity, dependencies);
      }
      subscribe(
        `private-${entity.id}`,
        PUSHER.EVENTS.UPDATE,
        ENTITIES.PUSHER_UPDATE
      );
    }

    yield put(createAction(ENTITIES.GET_COMPLETE));
    return result;
  } catch (error) {
    yield put(createAction(ENTITIES.GET_COMPLETE));
    yield cancel();
  }
}

// -- ROOT WATCHERS -- //

export function* watchEntitiesSagas() {
  yield takeEvery(ENTITIES.GET, entityChoiceSaga);
  yield takeLatest(ENTITIES.POST, createEntitySaga, ENTITIES, undefined);
}
